import React from "react";
import { CategoryDetails } from "../lib/types";
import Hero from "../sections/Hero";
import Category from "../components/Category";
import Footer from "../components/Footer";
import SpotlightProd from "../sections/SpotlightProd";
import Info from "../sections/Info";
import { motion } from "framer-motion";

function Home() {
  let categories: CategoryDetails[] = [
    {
      id: 1,
      title: "Headphones",
      img: require("../images/hps.png"),
    },
    {
      id: 2,
      title: "Speakers",
      img: require("../images/spks.png"),
    },
    {
      id: 3,
      title: "Earphones",
      img: require("../images/eps.png"),
    },
  ];
  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        className="bg-home bg-black md:bg-none bg-cover bg-left relative h-screen overflow-hidden grid place-items-center w-full"
      >
        <Hero />
        <div className="bg-black/40 h-full w-full absolute top-0 left-0"></div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        className="bg-white text-black relative min-h-screen mt-24 flex flex-col justify-center items-center gap-8 md:gap-24 w-full"
      >
        <section className="min-h-[20vh] w-11/12 sm:w-10/12 lg:w-9/12 grid sm:grid-cols-3 gap-14 md:gap-8">
          {categories.map((category) => {
            return <Category productdetail={category} />;
          })}
        </section>
        <SpotlightProd />
        {/* <Info/> */}
        <Footer />
      </motion.div>
    </>
  );
}

export default Home;
